import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * Hook to automatically track page views on route changes
 *
 * Usage:
 * ```typescript
 * // In App.tsx or router component
 * function App() {
 *   usePageTracking();
 *   return <Routes>...</Routes>;
 * }
 * ```
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever location changes.
    // document.title is set by react-helmet-async during render, so it reflects
    // the current page's title by the time this effect runs.
    trackPageView(location.pathname + location.search, document.title || undefined);
  }, [location]);
}
